export const SETLEADSLIST = "SETLEADSLIST";
export const SETLEADSLISTBYID = "SETLEADSLISTBYID";
export const SETLEADSSOURCE = "SETLEADSSOURCE";
export const SETLEADSTYPE = "SETLEADSTYPE";
export const SETLEADSQUALIFICATION = "SETLEADSQUALIFICATION";
export const SETLEADSCUSTOMERLIST = "SETLEADSCUSTOMERLIST";
export const SETLEADSCOUNT = "SETLEADSCOUNT";
export const SETLEADSFOLLWUPHISTORY = "SETLEADSFOLLWUPHISTORY";
export const SETASSIGNLIST = "SETASSIGNLIST";
export const SETLEADSREFERENCE = "SETLEADSREFERENCE";
export const SETATTACHMENTDATA = "SETATTACHMENTDATA";
